import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import HowItWorksPage from "./pages/HowItWorksPage";
import PerksPage from "./pages/PerksPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/how-it-works" element={<HowItWorksPage />} />
          <Route path="/perks" element={<PerksPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
